module.exports = "pegasus/assets/theme5/google.png";